module.exports = __webpack_public_path__ + "img/logo-14.1511660c.png";